import React from 'react';
import { motion } from 'framer-motion';
import { INSTAGRAM_URL, TIKTOK_URL } from '../../config';
import useInView from '../../hooks/useInView';
import styles from './FollowJourney.module.css';

/**
 * Follow the Journey — a single banner sentence with three inline buttons.
 * Mirrors the spec: prose + three small CTAs, not three big cards.
 */
export default function FollowJourney({ onNewsletter }) {
  const [ref, inView] = useInView({ threshold: 0.25 });

  return (
    <section id="follow" className={styles.section}>
      <div className={styles.shell} ref={ref}>
        <motion.p
          className={styles.sentence}
          initial={{ opacity: 0, y: 14 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        >
          Don't wanna miss an experience? Follow us on Instagram, TikTok,
          or sign up for the newsletter.
        </motion.p>

        <motion.div
          className={styles.actions}
          initial={{ opacity: 0, y: 12 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
        >
          <a
            className={styles.btn}
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
          >
            Instagram <span aria-hidden="true">↗</span>
          </a>
          <a
            className={styles.btn}
            href={TIKTOK_URL}
            target="_blank"
            rel="noreferrer"
          >
            TikTok <span aria-hidden="true">↗</span>
          </a>
          <button
            type="button"
            className={`${styles.btn} ${styles.btnSolid}`}
            onClick={onNewsletter}
          >
            Newsletter <span aria-hidden="true">→</span>
          </button>
        </motion.div>
      </div>
    </section>
  );
}
